import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { fetchPlayerMatches, type PlayerMatchHistoryResponse } from '@/lib/network';

const PLAYER_MATCHES_STALE_TIME_MS = 2 * 60 * 1000;
const PLAYER_MATCHES_GC_TIME_MS = 5 * 60 * 1000;

export type UseFetchPlayerMatchesOptions = Omit<
  UseQueryOptions<PlayerMatchHistoryResponse, Error>,
  'queryKey' | 'queryFn'
>;

export const useFetchPlayerMatches = (
  playerId: string | undefined,
  type: 'gameweek' | 'matchday' = 'matchday',
  options?: UseFetchPlayerMatchesOptions
) => {
  return useQuery<PlayerMatchHistoryResponse, Error>({
    queryKey: ['player-matches', playerId, type],
    queryFn: () => {
      if (!playerId) {
        throw new Error('Player ID is required');
      }
      return fetchPlayerMatches(playerId, type);
    },
    enabled: !!playerId,
    staleTime: PLAYER_MATCHES_STALE_TIME_MS,
    gcTime: PLAYER_MATCHES_GC_TIME_MS,
    ...options,
  });
};
